import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { setCookie } from 'app/common/utils/cookie.util';
import { PasswordValidator } from 'app/common/validators/password.validator';
import { UserValidator } from 'app/common/validators/user.validator';
import { ISignInResponse } from 'app/services/auth/auth.interface';
import { AuthService } from 'app/services/auth/auth.service';
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { MagicService } from 'app/services/wallet/magic/magic.service';
import { MetamaskService } from 'app/services/wallet/metamask/metamask.service';
import { eStatus, Web3Service } from 'app/services/web3/web3.service';
import { first } from 'rxjs';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {

  helpLink: string = 'https://discord.gg/2eJJPmDhJ3';
  signInFormGroup: FormGroup;
  isForgotPsw: boolean = false;
  recoveryPassFormGroup: FormGroup;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private magicService: MagicService,
    private metamaskService: MetamaskService,
    private toastService: ToastService
  ) {
    this.signInFormGroup = this.fb.group({
      username: this.fb.control('', [Validators.required, UserValidator.userloginValidator()]),
      password: this.fb.control('', [Validators.required, /* PasswordValidator.passwordloginValidator() */])
    });

    this.recoveryPassFormGroup = this.fb.group({
      email: this.fb.control('', [Validators.required, Validators.email]),
    });

  }

  ngOnInit(): void {
  }

  login(): void {
    this.authService.signIn(this.signInFormGroup.value).pipe(first())
      .subscribe(response => {
        if (response.status == "done") {
          let missingWallet: boolean = !response.walletAddress ? true : false;
          if (response.walletProvider === "magic") this.loginWithMagic(response, missingWallet);
          else this.loginWithMetamask(response, missingWallet);
        } else {
          console.log('errorLogin', response);
          this.toastService.genericError();
        }

      });
  }

  loginWithMetamask(response: ISignInResponse, missingWallet: boolean) {

    this.metamaskService.login(missingWallet
    );
    this.metamaskService.loggedStatus.subscribe(status => {
      if (status.status === eStatus.success) {
        {
          let metamaskSelectedWallet = status.value.selectedAddress ? status.value.selectedAddress : status.value.accounts[0]
          if (response.walletAddress.toLowerCase() === metamaskSelectedWallet.toLowerCase()) {
            setCookie('login', 'wallet', 30);
            setCookie('loginEmail', response.email, 30);
            setCookie('recordedWallet', response.walletAddress, 30);
            this.authService.routeAfterSuccessfulLogin(response);
          } else {
            console.log('wallet provided different');
            this.toastService.genericError('errorMsg.walletAlreadyUsed');
          }
        }
      }
    })
  }

  loginWithMagic(response: ISignInResponse, missingWallet: boolean) {
    this.magicService.login(
      response.email,
      missingWallet
    );
    this.magicService.loggedSuccessfully.subscribe(isLogged => {
      if (isLogged) {
        setCookie('login', 'magic', 30);
        setCookie('loginEmail', response.email, 30);
        setCookie('recordedWallet', response.walletAddress, 30);
        this.authService.routeAfterSuccessfulLogin(response);
      }
    })
  }

  forgotPassword() {
    this.authService.forgotPassword(this.recoveryPassFormGroup.get('email').value).subscribe(
      (response: any) => {
        if (response.status == 'done') {
          this.toastService.add({
            severity: "info",
            summary: 'shared.sent',
            detail: 'toastMessage.passwordSent',
          });
        }
        else this.toastService.genericError();
      }
    )

  }

}
